// import settingsAPI from '@/modules/settings/api/settings'
import miscServices from '@/services/misc'
import divisionServices from '@/services/divisions'
import store from '@/store'

export default {
  generateProjectNumber (proj) {
    const division = store.state.misc.divisions.find(d => d.id === proj.division)
    let projNum = division.ress_project_letter + '-' + division.division_prefix
    let num = parseInt(division.next_project_number)
    num = miscServices.getPaddedNumber(num)
    projNum += num
    divisionServices.incrementProjectNumber(division)
    return projNum
  },
  getProjectOverviewRoute (proj) {
    // Returns the name of the route to get to the specific project's overview page.
    // Since a project may be from any specific division, the overview route names
    // may differ.
    // It only returns the NAME of the route, you'll have to tack on any route params needed
    let ret = ''
    switch (proj.division_obj.division_type) {
      case 'S':
        ret = 'SnowOverview'
        break 
      case 'I':
        ret = 'IrrigationOverview'
        break 
      case 'L':
        ret = 'LawnOverview'
        break
      case 'C':
        ret = 'ConstructionOverview'
        break
    }
    return ret
  },
  getProjectEstimateRoute (proj) {
    let ret = ''
    switch (proj.division_obj.division_type) {
      case 'S':
        ret = 'SnowEstimate'
        break 
      case 'I':
        ret = 'IrrigationEstimate'
        break 
    }
    return ret
  }
}